module.exports = __webpack_public_path__ + "img/email.8c68e550.svg";